module.exports = {
      id: "angle-up-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#angle-up",
      toString: function () {
        return this.url;
      }
    }